import { createAsyncThunk } from "@reduxjs/toolkit";

export const retreiveBon = createAsyncThunk(
    '[ BON ] retreive one',
    async (bonId: string, thunk: any) => {
        return await thunk.extra.bonService.getBonById(bonId);
    }
)